
import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
const HowItsWork = ({ handleNext, type = 'rental_app' }) => {
  const [checkPolicy, setCheckPolicy] = useState(false)
  let location = useLocation().pathname

  const lng = useSelector((state) => state?.userAuth?.language)

  const handleMove = () => {
    if (checkPolicy === false && location != '/leasedBuilder' && location != '/rentalApp') {
      toast.error(t('invalid_terms'))
    } else {
      handleNext()
    }
  }

  let { t } = useTranslation()
  return (
    <>
      <div className='bg-white relative pt-5'>
        {type === 'co_signer_app' ? (
          <>
            <h2 className='text-[18px] font-bold'>{t('need_a_co_signer')}</h2>
            <p className='text-[14px]'>{t('co_signer_description')}</p>
            <div className='pt-5'>
              <h1 className='text-[18px] font-bold'>{t('how_its_work')}</h1>
              <p className='text-[14px]'>{t('co_signer_how_it_works')}</p>
              <div className=" flex text-center mt-2">
                <h2 className=''> <span> <input type="checkbox" onChange={() => setCheckPolicy(!checkPolicy)} id="check_box" className='w-4 h-4' /><label htmlFor='check_box' className=' cursor-pointer '> {t('privacy_policy_agree')}</label> </span><a href={lng === "en" ? "/privacy" : "/sp/privacy"} target='_blank' className='underline decoration-[#F79F15] text-[#F79F15]'>{t('privacy_ploicy')}</a> {t('and')} <a href={lng === "en" ? "/terms" : "/sp/terms"} target='_blank' className='underline text-[#F79F15] decoration-[#F79F15]'>{t('terms_agree')}</a></h2>
              </div>
            </div>
          </>
        ) : (
          <>
            <h2 className='text-[18px] font-bold'>
              {location === '/leasedBuilder' ? t('try_lease_b') : t('try_rental_app')}
            </h2>
            <p className='text-[14px]'>
              {location === '/leasedBuilder' ? t('free_lease') : t('pay_ren_app')}
            </p>
            <div className='pt-5'>
              <h1 className='text-[18px] font-bold'>{t('how_its_work')}</h1>
              <p className='text-[14px]'>
                {location === '/leasedBuilder' ? t('lease_b') : t('rent_desc')}
              </p>
            </div>
          </>
        )}

        <div className='pt-[5rem] flex justify-center items-center'>
          <button className='font-semibold bg-[#F79F15] xl:w-[20%] lg:w-[20%] md:w-[20%] w-full py-2 text-white rounded-md' onClick={() => handleMove()}>{t('get_start')}</button>
        </div>

        {/* <div className='pt-5'>
          <h1 className='text-[18px] font-bold '>Discolsure:</h1>
          <div className="border rounded-md p-3 my-2">
            <p className='text-center font-bold '>Rental Leased Agreement </p>
          </div>
        </div> */}
      </div>
    </>
  )
}

export default HowItsWork